import { ONE_KILOBYTE, ONE_SECOND } from '@lucidlink/uicore';
export const bytesToMb = (bytes) => Number(bytes / BigInt(ONE_KILOBYTE)) / ONE_KILOBYTE;
export const secondsSince = (startTime) => (Date.now() - startTime) / ONE_SECOND;
export const getFolderDepth = (zipPath) => zipPath.split('/').length - 1;
export const toErrorMessage = (error) => error instanceof Error ? error.message : String(error);
